<template>
    <div class="extended-panel details-panel routed-extended-page">
        <activity-panel v-if="truck" class="side-panel-fill" :truck="truck" @lostfocus="goToTruckDetails" />
    </div>
</template>

<script>
import ActivityPanel from '@/components/panels/ActivityPanel.vue'
import truckPageGuard from '@/mixins/truckPageGuard'

export default {
    name: 'AnalyzePage',
    mixins: [truckPageGuard],
    components: { ActivityPanel }
}
</script>
